// Hero.js
import React from "react";
import CodiCharacter from "../../../../assets/images/CodiCharacter.png";

const Hero = ({
  selected,
  onClick,
  total,
  imageSrc,
  onMouseEnter,
  onMouseLeave,
}) => {
  const showBorder = selected && total > 1;

  return (
    <img
      src={imageSrc || CodiCharacter}
      alt="Hero"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`min-w-[64px] w-16 h-20 rounded-[20px] cursor-pointer transition-transform duration-200 hover:scale-105 ${
        showBorder ? "outline outline-[3px] outline-sky-300" : ""
      }`}
    />
  );
};

export default Hero;
